import React, { useState, useEffect } from "react";
import "./Tree.css";
import axios from "axios";
import { useTranslation } from "react-i18next";

function Tree({ id }) {
  const [speciesData, setSpeciesData] = useState({});
  const [mainImage, setMainImage] = useState("");
  const [lang] = useState(localStorage.getItem("lang") || "en");
  const { t } = useTranslation("global");

  const fetchSpeciesData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/speciesDetails/${id}`
      );
      const data = response.data.data;
      setSpeciesData(data);
      if (data.images && data.images.length > 0) {
        setMainImage(`${data.images[1]}`); // default (2).jpg
      }
    } catch (error) {
      console.error("Error Getting Tree Info:", error);
    }
  };

  useEffect(() => {
    if (!id || id < 1 || id > 49 || id === "NaN") {
      window.location.href = "/species";
      return;
    }
    fetchSpeciesData();
  }, [id]);

  const handleImageClick = (image) => {
    setMainImage(`${image}`);
  };

  return (
    <div className="tree">
      {mainImage && (
        <img src={mainImage} alt="Species Main" className="tree-image" />
      )}
      <div className="extra-tree">
        {speciesData.images &&
          speciesData.images.map((img, index) => (
            <img
              key={index}
              src={`${img}`}
              alt={`Species ${index + 1}`}
              onClick={() => handleImageClick(img)}
            />
          ))}
      </div>

      {/* Info Section */}
      <div className="tree-info">
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.name")}
          </div>
          <div className="tree-name">
            {speciesData.name_en} {speciesData.published}
          </div>
        </div>
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.common_name")}
          </div>
          <div className="tree-name">{speciesData.name_bn}</div>
        </div>
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.family")}
          </div>
          <div className="tree-name">{speciesData.family}</div>
        </div>
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.synonym")}
          </div>
          <div className="tree-name">{speciesData.synonym}</div>
        </div>
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.iucn")}
          </div>
          <div className="tree-name">{speciesData.iucn}</div>
        </div>

        {/* Long fields */}
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.description")}
          </div>
          <div className={`tree-name ${lang === "bn" ? "bangla-font" : ""}`}>
            {lang === "bn"
              ? speciesData.description_bn
              : speciesData.description}
          </div>
        </div>
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.phenology")}
          </div>
          <div className={`tree-name ${lang === "bn" ? "bangla-font" : ""}`}>
            {lang === "bn" ? speciesData.phenology_bn : speciesData.phenology}
          </div>
        </div>
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.features")}
          </div>
          <div className={`tree-name ${lang === "bn" ? "bangla-font" : ""}`}>
            {lang === "bn" ? speciesData.features_bn : speciesData.features}
          </div>
        </div>
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.adaptations")}
          </div>
          <div className={`tree-name ${lang === "bn" ? "bangla-font" : ""}`}>
            {lang === "bn"
              ? speciesData.adaptations_bn
              : speciesData.adaptations}
          </div>
        </div>
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.distribution")}
          </div>
          <div className="tree-name">
            {speciesData?.distribution?.split("\n").map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
          </div>
        </div>
        <div className="tree-section">
          <div className={`tree-title ${lang === "bn" ? "bangla-font" : ""}`}>
            {t("tree.uses")}
          </div>
          <div className={`tree-name ${lang === "bn" ? "bangla-font" : ""}`}>
            {lang === "bn" ? speciesData.uses_bn : speciesData.uses}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tree;
